/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-useless-constructor */
/* eslint-disable prefer-template */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/no-unescaped-entities */
import React, {useRef, useEffect, useState, Suspense} from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import BoxBorder from './BoxBorder';
import BoxBorderSmall from './BoxBorderSmall';
import BoxBorderBlue from './BoxBorderBlue';
import BoxBorderTextModule from './BoxBorderTextModule';
import BoxBorderIceberg from './BoxBorderIceberg';
import BlueArrowRight from './BlueArrowRight';
import WhiteArrowDown from './WhiteArrowDown';
import FooterArrows from './FooterArrows';
import {
    animateSpeedometerSection, 
    animateLiveMarketsWheel, 
    animateSectionTitle,
    animateIcebergSection,
    animateSweepTheStackSection,
    animateOutroSection
} from './animationTimelines';
import renderBackgroundDots from './BackgroundDots';
import './LiveMarketsPage.scss';
import DesktopBg from './sticky-button_desktop.svg';
import MobileBg from './stickyButtonMobile';

// Lazy load lottie animation components
import CubeDance from './animations/headerCubes/cubeDance';
import SpeedometerLiquidity from './animations/speedometers/speedometerLiquidity';
import SpeedometerSize from './animations/speedometers/speedometerSize';
import SpeedometerAnonymity from './animations/speedometers/speedometerAnonymity';
import SpeedometerPriceVsSpeed from './animations/speedometers/speedometerPriceVsSpeed';
import LiveMarketWheel from './animations/liveMarketWheel/liveMarketWheel';
import Iceberg from './animations/iceberg/iceberg';
import IconCheck from './animations/howItWorksIcons/iconCheck';
import IconPlus from './animations/howItWorksIcons/iconPlus';
import IconProcess from './animations/howItWorksIcons/iconProcess';
import IconTicket from './animations/howItWorksIcons/iconTicket';
import CardSpot from './animations/cardSpot/cardSpot';
import FunnelSpot from './animations/funnelSpot/funnelSpot';

gsap.registerPlugin(ScrollTrigger);


const LiveMarketsPage = () => {

    const headerCubeRef = useRef();
    const speedometerLiquidityRef = useRef();
    const speedometerSizeRef = useRef();
    const speedometerPriceVsSpeedRef = useRef();
    const speedometerAnonymityRef = useRef();
    const liveMarketWheelRef = useRef();
    const icebergRef = useRef();
    const iconCheckRef = useRef();
    const iconPlusRef = useRef();
    const iconProcessRef = useRef();
    const iconTicketRef = useRef();
    const cardSpotRef = useRef();
    const funnelSpotRef = useRef();

    useEffect(() => {

        // Render Background Dots
        renderBackgroundDots('liveMarkets__contentBackground');

        // Initialize gsap animations
        animateSectionTitle();
        animateOutroSection();
        animateSpeedometerSection(speedometerLiquidityRef, speedometerSizeRef, speedometerAnonymityRef, speedometerPriceVsSpeedRef);
        animateLiveMarketsWheel(liveMarketWheelRef);
        animateIcebergSection(icebergRef, iconCheckRef, iconPlusRef, iconProcessRef, iconTicketRef);
        animateSweepTheStackSection(cardSpotRef, funnelSpotRef);

    }, []);


    return (
        <div className="liveMarkets">

            <a href="https://marketaxess.tfaforms.net/f/live-markets-request-a-demo" className="liveMarkets__floatingButton" target="_blank" rel="noopener noreferrer">
                <div className="liveMarkets__floatingButon__inner">
                    <span className="liveMarkets__floatingButton__text">Book a live markets demo</span>
                    <DesktopBg className="sticky-button-desktop" />
                    <MobileBg className="sticky-button-mobile"/>
                </div>
            </a>

            <div className="liveMarkets__headerCubes" id="liveMarkets__headerCubes">
                <div className="container">

                    <div className="liveMarkets__headerCubes__text">
                        <h1>Looking for a new protocol to trade IG and HY blocks?</h1>

                        <a href="https://www.marketaxess.com/pdf/live_markets_infographic.pdf" target="_blank" rel="noopener noreferrer" className="button">Download the PDF</a>

                    </div>
                    
                    <div className="liveMarkets__headerCubes__animation">
                        <CubeDance 
                            lottieRef={headerCubeRef}
                            loop={false}
                        />
                    </div>

                </div>
            </div>

            <div className="liveMarkets__content">
                <canvas id="liveMarkets__contentBackground"></canvas>

                <div className="container liveMarkets__speedometersContainer">

                    <h2 id="speedometersTitle">What factors are you motivated by?</h2>

                    <div className="liveMarkets__speedometersGrid" id="liveMarkets__speedometersGrid">

                        <BoxBorder id={'speedometersGridBorder'}/>

                        <div className="liveMarkets__speedometer" id="liquiditySpeedometer">
                            <span id="liquidityLabel">Liquidity?</span>

                                <SpeedometerLiquidity 
                                    lottieRef={speedometerLiquidityRef}
                                    loop={false}
                                    className="liveMarkets__speedometerAnimation"
                                />
    
                            <div className="liveMarkets__speedometerLabels" id="liquiditySubLabels">
                                <span>Very Illiquid</span>
                                <span>Very Liquid</span>
                            </div>
                        </div>

                        <div className="liveMarkets__speedometer">
                            <span id="sizeLabel">Size?</span>

                                <SpeedometerSize 
                                    lottieRef={speedometerSizeRef}
                                    loop={false}
                                    className="liveMarkets__speedometerAnimation"
                                />
    
                            <div className="liveMarkets__speedometerLabels" id="sizeSubLabels">
                                <span>0mm</span>
                                <span>5mm</span>
                                <span>10mm</span>
                                <span>15mm</span>
                                <span>20mm</span>
                            </div>
                        </div>

                        <div className="liveMarkets__speedometer">
                            <span id="anonymityLabel">Anonymity?</span>

                                <SpeedometerAnonymity 
                                    lottieRef={speedometerAnonymityRef}
                                    loop={false}
                                    className="liveMarkets__speedometerAnimation"
                                />
    
                            <div className="liveMarkets__speedometerLabels" id="anonymitySubLabels">
                                <span>Disclosed</span>
                                <span>Undisclosed</span>
                            </div>
                        </div>

                        <div className="liveMarkets__speedometer">
                            <span id="priceSpeedLabel">Price vs Speed?</span>

                                <SpeedometerPriceVsSpeed
                                    lottieRef={speedometerPriceVsSpeedRef}
                                    loop={false}
                                    className="liveMarkets__speedometerAnimation"
                                />
    
                            <div className="liveMarkets__speedometerLabels" id="priceSpeedSubLabels">
                                <span>Price</span>
                                <span>Speed</span>
                            </div>
                        </div>

                    </div>

                    <div className="liveMarkets__protocol" id="liveMarkets__protocol">

                            <div className="liveMarkets__protocolLine">
                                <span className="animatedLine protocolLine" id="protocolLine"/>
                            </div>
                            <div></div>
                            <div></div>

                            <div className="liveMarkets__protocolTextWrapper">
                                <div className="liveMarkets__protocolTextBackground"></div>
                                <BoxBorderSmall id={'protocolTextBorder'}/>
                                <p className="liveMarkets__protocolText">Make a smart move by selecting the most advantageous protocol for your trade</p>
                            </div>
                            <div className="liveMarkets__protocolArrow">
                                <BlueArrowRight />
                            </div>
                            <div className="liveMarkets__protocolSideTextWrapper">
                                <div className="liveMarkets__protocolSideTextBackground"></div>
                                <BoxBorderBlue id={'protocolSideTextBorder'}/>
                                <p className="liveMarkets__protocolSideText">Choose RFQ when time is more important than price</p>
                            </div>

                            <div className="liveMarkets__protocolLine">
                                <span className="animatedLine protocolLine" id="protocolLine2"/>
                            </div>
                            <div></div>
                            <div></div>

                    </div>

                    <div className="liveMarkets__liveMarketsWheel">

                        <div className="liveMarkets__liveMarketsWheel__wrapper">
                            <div className="liveMarkets__liveMarketsWheel__text">
                                <h3>Choose <span>Live Markets</span> when time is on your side</h3>
                            </div>

                            <div className="liveMarkets__lieMarketsWheel__animation">
                                <LiveMarketWheel
                                    lottieRef={liveMarketWheelRef}
                                    loop={false}
                                />
                            </div>
                        </div>

                        <span className="liveMarkets__liveMarketsWheel__bottomNote">Live executable prices. Ready to trade.</span>

                    </div>

                </div>

                <div className="liveMarkets__sectionTitle">
                    <div className="container">
                        <h2><span>Live Markets:</span> How it works</h2>
                    </div>
                </div>

                <div className="container liveMarkets__howItWorksContainer">

                    <div className="liveMarkets__howItWorks__textModule liveMarkets__howItWorks__textModule-1">
                        <BoxBorderTextModule id={'howItWorks__textModuleBorder1'}/>
                        <h3>You need to sell $15mm bonds and prefer to keep it discreet</h3>
                        <span>Iceberg your $15mm trade on <span className="boldText">Live Markets</span></span>
                    </div>

                    <div className="liveMarkets__howItworksLine">
                        <span className="animatedLine animatedLine--blue howItWorksLine" id="howItWorksLine1"/>
                    </div>

                    <div className="liveMarkets__iceberg" id="liveMarkets__iceberg">
                        <BoxBorderIceberg id={'liveMarkets__icebergBorder'}/>
                            <Iceberg
                                lottieRef={icebergRef}
                                className="liveMarkets__iceberg__animation"
                            />
                        <div className="liveMarkets__iceberg__text">
                            <p className="liveMarkets__icebergText-1">Post your offer at the price you want</p>
                            <p className="liveMarkets__icebergText-2">Enter an order on 15mm with just 5mm visible size</p>
                            <p className="liveMarkets__icebergText-3">Set a time limit</p>
                            <p className="liveMarkets__icebergText-4">Your full size is hidden. If you trade a partial, your unfilled balance will be entered into Multiparty Workup and remain in the stack</p>
                        </div>

                    </div>

                    <WhiteArrowDown />

                    <div className="liveMarkets__howItWorks__iconModule liveMarkets__howItWorks__iconModule-1">

                        <div className="liveMarkets__howItWorks__iconAnimation" id="howItWorks__iconCheck">
                            <IconCheck
                                lottieRef={iconCheckRef}
                                loop={false}
                            />
                        </div>

                        <div className="liveMarkets__howItWorks__iconText">
                            <p>A buyer confirms a purchase at 5mm</p>
                        </div>

                    </div>

                    <div className="liveMarkets__howItworksLine">
                        <span className="animatedLine animatedLine--blue howItWorksLine" id="howItWorksLine2"/>
                    </div>

                    <div className="liveMarkets__howItWorks__iconModule liveMarkets__howItWorks__iconModule-2">

                        <div className="liveMarkets__howItWorks__iconAnimation" id="howItWorks__iconPlus">
                            <IconPlus
                                lottieRef={iconPlusRef}
                                loop={false}
                            />
                        </div>

                        <div className="liveMarkets__howItWorks__iconText">
                            <p>Automatically enter into a blind multi-party workup and sell an additional 3mm</p>
                        </div>

                    </div>

                    <div className="liveMarkets__howItworksLine">
                        <span className="animatedLine animatedLine--blue howItWorksLine" id="howItWorksLine3"/>
                    </div>

                    <div className="liveMarkets__howItWorks__iconModule liveMarkets__howItWorks__iconModule-3">

                        <div className="liveMarkets__howItWorks__iconAnimation" id="howItWorks__iconTicket">
                            <IconTicket
                                lottieRef={iconTicketRef}
                                loop={false}
                            />
                        </div>

                        <div className="liveMarkets__howItWorks__iconText">
                            <p>You receive a ticket of 8mm sold. You can rerack your offer or leave it resting</p>
                        </div>

                    </div>

                    <div className="liveMarkets__howItworksLine">
                        <span className="animatedLine animatedLine--blue howItWorksLine" id="howItWorksLine4"/>
                    </div>

                    <div className="liveMarkets__howItWorks__iconModule liveMarkets__howItWorks__iconModule-4">

                        <div className="liveMarkets__howItWorks__iconAnimation" id="howItWorks__iconProcess">
                            <IconProcess
                                lottieRef={iconProcessRef}
                            />
                        </div>

                        <div className="liveMarkets__howItWorks__iconText">
                            <p>This process repeats until all your bonds are sold.</p>
                        </div>

                    </div>


                    <div className="liveMarkets__howItWorks__textModule liveMarkets__howItWorks__textModule-2">
                        <BoxBorderTextModule id={'howItWorks__textModuleBorder2'}/>
                        <h3>You want to buy $10mm on <span className="boldText">Live Markets</span></h3>
                        <span>Sweep the Stack</span>
                    </div>

                    <div className="liveMarkets__howItworksLine">
                        <span className="animatedLine animatedLine--alt howItWorksLine" id="howItWorksLine5"/>
                    </div>

                    <div className="liveMarkets__cardSpot" id="liveMarkets__cardSpot">
                        <CardSpot
                            lottieRef={cardSpotRef}
                            loop={false}
                            className="liveMarkets__cardSpot__animation"
                        />

                        <p>You want to buy 10mm, you see:</p>

                    </div>

                    <div className="liveMarkets__tripleLines liveMarkets__tripleLines--01">

                        <div className="liveMarkets__tripleLinesWrapper">
                            <span className="liveMarkets__tripleLine liveMarkets__tripleLine--01" />
                            <span className="liveMarkets__tripleLine liveMarkets__tripleLine--02" />
                            <span className="liveMarkets__tripleLine liveMarkets__tripleLine--03" />
                        </div>

                    </div>

                    <div className="liveMarkets__sweepCards">

                        <div className="liveMarkets__sweepCard liveMarkets__sweepCard-1">
                            <p>5mm at $98.25</p>
                        </div>

                        <div className="liveMarkets__sweepCard liveMarkets__sweepCard-2">
                            <p>2mm at $98.375</p>
                        </div>

                        <div className="liveMarkets__sweepCard  liveMarkets__sweepCard-3">
                            <p>3mm at $98.50</p>
                        </div>

                    </div>

                    <div className="liveMarkets__tripleLines liveMarkets__tripleLines--02">

                        <div className="liveMarkets__tripleLinesWrapper">
                            <span className="liveMarkets__tripleLine liveMarkets__tripleLine--01" />
                            <span className="liveMarkets__tripleLine liveMarkets__tripleLine--02" />
                            <span className="liveMarkets__tripleLine liveMarkets__tripleLine--03" />
                        </div>

                        <div className="liveMarkets__tripleLinesHoriz">
                            <span className="liveMarkets__tripleLinesHorizLine liveMarkets__tripleLinesHorizLine--01" />
                            <span className="liveMarkets__tripleLinesHorizLine liveMarkets__tripleLinesHorizLine--02" />
                        </div>
                    </div>

                    <div className="liveMarkets__funnelSpot" id="liveMarkets__funnelSpot">
                        <div className="liveMarkets__funnelSpot__animation">
                            <FunnelSpot
                                lottieRef={funnelSpotRef}
                                loop={false}
                            />
                        </div>

                        <div className="liveMarkets__funnelSpot__text">
                            <p>You can sweep the 3 offers and receive a single weighted average price ticket with MarketAxess as the counterparty. You remain fully anonymous to the sellers.</p>
                        </div>
                    </div>
                    
                    <a href="https://www.marketaxess.com/pdf/live_markets_infographic.pdf" target="_blank" rel="noopener noreferrer" className="liveMarkets__outroButton">Download the PDF</a>

                </div>

                <div className="liveMarkets__outro">

                    <FooterArrows />
                    
                    <div className="container">

                        <h2>Live Markets</h2>
                        <span>A new path to better execution</span>

                    </div>
                </div>
            </div>


        </div>
    );
    
}

export default LiveMarketsPage;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/LiveMarketsPage.jsx